const useEffect = subscribe => ({ subscribe });
export default useEffect;
